/**
 * Single source of truth for the client portal color scheme and typography (ENB-565).
 *
 * The portal had drifted into five different accents: Bulma's default teal (#00d1b2),
 * MUI's default blue (#1976d2), the header's #3298dc, the mobile header's green
 * (#3a8a5f) and the dashboard's brand blue (#007DD1). Everything now derives from
 * the values below.
 *
 * These are mirrored as CSS custom properties (--eli-*) in styles/sass/index.scss so
 * the plain .css files can use them, and are fed into the MUI theme in theme.js.
 * Changing a color here means changing it in that :root block too.
 */
export const BRAND = {
  // Core blue, taken from the dashboard cards / login screen the client signed off on.
  primary: "#007DD1",
  primaryLight: "#4BA4DF",
  primaryDark: "#005F9E",

  // Tinted surfaces built from the primary.
  primarySoft: "rgba(0, 125, 209, 0.10)",
  primaryBorder: "rgba(0, 125, 209, 0.25)",
  primaryShadow: "rgba(0, 125, 209, 0.28)",
  gradient: "linear-gradient(135deg, #007DD1 0%, #4BA4DF 100%)",

  // Status colors. These were originally Bulma's pale tag colours, kept so Bulma
  // tags and MUI chips agreed. All the Bulma tags are gone now, and those values
  // were unreadable as filled chips (#ffdd57 "Unpaid" on white in particular), so
  // these are picked for contrast instead - see contrastText in theme.js.
  success: "#2e7d32",
  warning: "#ffb300",
  danger: "#d32f2f",

  // Neutrals
  textPrimary: "#1f2937",
  textSecondary: "#4a5568",
  border: "#e1e8ed",

  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
  ].join(", "),
};

export default BRAND;
